import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ImplementerSnapshotSummary } from '../../../../models/implementer/implementer.models';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'implementer-merge-page',
  templateUrl: 'implementer-merge-page.html',
})
export class ImplementerMergePage {
  snapshotSummary: ImplementerSnapshotSummary;
  config = AppConfig.settings;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
    this.snapshotSummary = this.navParams.get('snapshotSummary');
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-merge/implementer-merge/implementer-merge-page.ts